<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col
        lg="12"
        style="display:block; text-align:center;padding-bottom:15px;font-size:1.2em;"
        v-if="total > 0"
      >
        <span style="padding:5px;">Total Records:</span>
        <b style="border-right:1px solid white; padding-right:5px;">{{
          total
        }}</b>
        <span style="padding:5px;">Total Price:</span>
        <b
          >${{
            totalPrice.toFixed(2).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,")
          }}</b
        >

        <b-button
          class="download-button"
          variant="primary"
          size="lg"
          @click="
            downloadExcel(
              $http,
              {
                prodModel: modelParam,
                sub_division: locationParam,
                client_location: locationParam,
                prodGroup: productGroupParam,
                date_from: from(dateFromParam),
                date_to: to(dateToParam)
              },
              setLoading,
              excelDownload,
              'TableReport'
            )
          "
        >
          <LoadingCard
            style="display:inline-block;"
            v-if="loadingButton"
          ></LoadingCard>
          <i v-else class="fa fa-file-excel-o" aria-hidden="true"></i>
          Download
        </b-button>
      </b-col>
      <b-col lg="12">
        <c-table :table-data="data" :fields="fields" :caption="title"></c-table>
        <p v-if="message !== ''">{{ message }}</p>
        <div v-show="loading" class="sk-double-bounce">
          <div class="sk-child sk-double-bounce1"></div>
          <div class="sk-child sk-double-bounce2"></div>
        </div>
      </b-col>
    </b-row>
    <!--/.row-->
  </div>
</template>

<script>
import LoadingCard from "../../../components/shared/LoadingCard.vue";
import cTable from "./Table.vue";
import { downloadExcel, from, to } from "../../../utils/Utils";
export default {
  props: [
    "location",
    "productGroup",
    "type",
    "date_from",
    "date_to",
    "productModel",
    "prg",
    "clients"
  ],
  name: "Tables",
  components: { cTable, LoadingCard },
  data: () => {
    return {
      downloadExcel: downloadExcel,
      from: from,
      to: to,
      parameters: {},
      locationParam: "",
      excelDownload: "",
      loadingButton: false,
      loadingExcel: false,
      clientsId: "",
      productGroupParam: "",
      dateFromParam: "",
      modelParam: "",
      dateToParam: "",
      title: "",
      loading: true,
      data: [],
      total: 0,
      totalPrice: 0,
      fields: [
        { key: "fnsid", label: "FNSID", sortable: true },
        { key: "fnsra", label: "RANUM", sortable: true },
        { key: "locat", label: "Location" },
        { key: "sernm", label: "Serial#" },
        {
          key: "pMake",
          label: "Manufacturer",
          sortable: true,
          style: "width: 250px"
        },
        { key: "pMode", label: "Model" },
        {
          key: "compl",
          label: "Complaint",
          sortable: true,
          tdClass: "complaintClass"
        },
        { key: "loctn", label: "Status", sortable: true },
        { key: "price", label: "Price", sortable: true }
      ],
      message: ""
    };
  },
  methods: {
    setLoading(loading) {
      this.loadingButton = loading;
    },
    fetchData(urlSufix, params) {
      this.loading = true;
      this.$http.get(`api/tables/${urlSufix}.php`, { params }).then(
        res => {
          if (res.data && res.data.records) {
            this.data = res.data.records;
            this.loading = false;
            this.total = res.data.records.length;
            res.data.records.forEach(obj => {
              if (obj.price !== undefined) {
                this.totalPrice += parseFloat(obj.price.replace("$", ""));
              }
            });
          } else {
            this.message = res.data.message;
            this.loading = false;
          }
        },
        err => {
          this.loading = false;
          console.log(err);
        }
      );
    }
  },
  mounted() {
    if (this.type == "financial-subdivision") {
      this.locationParam = this.location;
      this.title = this.location + " Region Financial";
    } else if (this.type != "top") {
      this.locationParam = this.location.substring(
        0,
        this.location.lastIndexOf("(")
      );
      this.productGroupParam = this.productGroup.substring(
        0,
        this.productGroup.lastIndexOf("(")
      );

      if (this.productModel) {
        this.modelParam = this.productModel.substring(
          0,
          this.productModel.lastIndexOf("(")
        );
      }

      this.title =
        this.type.toLocaleUpperCase() +
        " - " +
        this.productGroupParam +
        " in " +
        this.locationParam;
    } else {
      this.locationParam = this.location;
      this.productGroupParam = this.prg.substring(0, this.prg.lastIndexOf("("));
      this.title = this.prg + " Shipped to " + this.locationParam;
    }

    this.clientsId = this.clients;
    this.dateFromParam = this.date_from;
    this.dateToParam = this.date_to;

    if (this.type === "Received") {
      this.parameters = {
        client_location: this.locationParam,
        prodGroup: this.productGroupParam,
        date_from: this.dateFromParam,
        date_to: this.dateToParam
      };
      this.excelDownload =
        process.env.VUE_APP_TRACKER_URL + "api/tables/recieved.php";
      this.fetchData("recieved", this.parameters);
    }
    if (this.type === "top" || this.type === "Shipped") {
      this.excelDownload =
        process.env.VUE_APP_TRACKER_URL + "api/tables/shipped.php";
      this.parameters = {
        client_location: this.locationParam,
        prodGroup: this.productGroupParam,
        date_from: this.dateFromParam,
        date_to: this.dateToParam,
        prodModel: this.modelParam
      };
      this.fetchData("shipped", this.parameters);
    }
    if (this.type === "OEM") {
      this.excelDownload =
        process.env.VUE_APP_TRACKER_URL + "api/tables/oem_backlog.php";
      this.parameters = {
        client_location: this.locationParam,
        prodGroup: this.productGroupParam
      };
      this.fetchData("oem_backlog", this.parameters);
    }
    if (this.type === "OEMShip") {
      this.excelDownload =
        process.env.VUE_APP_TRACKER_URL + "api/tables/oem_delivered.php";
      this.parameters = {
        client_location: this.locationParam,
        prodGroup: this.productGroupParam,
        date_from: this.dateFromParam,
        date_to: this.dateToParam
      };
      this.fetchData("oem_delivered", this.parameters);
    }
    if (this.type === "ber") {
      this.excelDownload =
        process.env.VUE_APP_TRACKER_URL + "api/tables/ber.php";
      this.parameters = {
        client_location: this.locationParam,
        prodGroup: this.productGroupParam,
        date_from: this.dateFromParam,
        date_to: this.dateToParam,
        prodModel: this.modelParam
      };
      this.fetchData("ber", this.parameters);
    }
    if (this.type === "eol") {
      this.excelDownload =
        process.env.VUE_APP_TRACKER_URL + "api/tables/eol.php";
      this.parameters = {
        client_location: this.locationParam,
        prodGroup: this.productGroupParam,
        date_from: this.dateFromParam,
        date_to: this.dateToParam
      };
      this.fetchData("eol", this.parameters);
    }
    if (this.type === "ntf") {
      this.excelDownload =
        process.env.VUE_APP_TRACKER_URL + "api/tables/ntf.php";
      this.parameters = {
        client_location: this.locationParam,
        prodGroup: this.productGroupParam,
        date_from: this.dateFromParam,
        date_to: this.dateToParam
      };
      this.fetchData("ntf", this.parameters);
    }
    if (this.type === "war") {
      this.excelDownload =
        process.env.VUE_APP_TRACKER_URL + "api/tables/war.php";
      this.parameters = {
        client_location: this.locationParam,
        prodGroup: this.productGroupParam,
        date_from: this.dateFromParam,
        date_to: this.dateToParam
      };
      this.fetchData("war", this.parameters);
    }
    if (this.type === "backlog") {
      this.excelDownload =
        process.env.VUE_APP_TRACKER_URL + "api/tables/back.php";
      this.parameters = {
        client_location: this.locationParam,
        prodGroup: this.productGroupParam,
        prodModel: this.modelParam
      };
      this.fetchData("back", this.parameters);
    }
    if (this.type === "city") {
      this.excelDownload =
        process.env.VUE_APP_TRACKER_URL + "api/tables/shipped.php";
      this.parameters = {
        client_location: this.locationParam,
        prodGroup: this.prg,
        date_from: this.dateFromParam,
        date_to: this.dateToParam
      };
      this.fetchData("shipped", this.parameters);
    }
    if (this.type === "SubDivisionBacklog") {
      this.excelDownload =
        process.env.VUE_APP_TRACKER_URL + "api/tables/subdivision_backlog.php";
      this.parameters = {
        client_location: this.locationParam,
        prodGroup: this.productGroupParam
      };
      this.fetchData("subdivision_backlog", this.parameters);
    }
    if (this.type === "SubDivisionDelivered") {
      this.excelDownload =
        process.env.VUE_APP_TRACKER_URL +
        "api/tables/subdivision_delivered.php";
      this.parameters = {
        client_location: this.locationParam,
        prodGroup: this.productGroupParam,
        date_from: this.dateFromParam,
        date_to: this.dateToParam
      };
      this.fetchData("subdivision_delivered", this.parameters);
    }
    if (this.type === "financial-subdivision") {
      this.fields = [
        { key: "location", label: "Location", sortable: true },
        { key: "ranum", label: "RA#", sortable: true },
        {
          key: "shipDate",
          label: "Ship Date",
          formatter: (value, key, item) => {
            return this.$formatUSDate(item.shipDate);
          }
        },
        { key: "invNumber", label: "Invoice #", sortable: true },
        { key: "invDate", label: "Invoice Date", sortable: true },
        { key: "po", label: "PO#", sortable: true },
        { key: "amount", label: "Amount", sortable: true }
      ];
      this.excelDownload =
        process.env.VUE_APP_TRACKER_URL + "api/tables/subdivision_finance.php";
      this.parameters = {
        sub_division: this.locationParam,
        date_from: this.dateFromParam,
        date_to: this.dateToParam
      };
      this.fetchData("subdivision_finance", this.parameters);
    }
  }
};
</script>
<style>
.complaintClass {
  width: 200px;
}
.download-button {
  margin: auto;
  float: right;
  font-weight: 600;
  padding: 0.4em;
  font-size: 0.9em;
}
.sk-double-bounce {
  height: 20px !important;
  width: 20px !important;
  line-height: 55px;
  margin: auto;
}
.download-button:hover {
  text-decoration: none !important;
  color: white;
}
.fa-file-excel-o {
  font-size: 1em;
  color: #ffffff68;
  transform: rotate(30deg);
  padding-right: 0.5em;
}
</style>
